import Vue from 'vue'
import * as firebase from 'firebase/app'
import VueParallaxJs from 'vue-parallax-js'
import 'firebase/storage'

import App from './App.vue'
import { firebaseConfig } from './firebase'
import router from './router'

Vue.use(VueParallaxJs)
Vue.config.productionTip = false

firebase.initializeApp(firebaseConfig)
const storageService = firebase.storage()
Vue.prototype.$storage = storageService
Vue.prototype.$db = storageService.ref()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
